import request from 'Request'
import UserStore from 'Store/user'

const ReportService = {
  async create({ sortingParams, filteringParams, searchParams, heading }) {
    const { virtualOffices } = UserStore.get()

    return request.post('/report/create', {
      sortingParams,
      filteringParams,
      searchParams,
      heading,
      virtualOfficeId: virtualOffices[0]?.id
    })
  }
}

export default ReportService
